import Helper from '../../Helpers/Helper.js';

export default class JSONSchema {
  type;
  title;
  properties;
  required;
  primaryKey;

  constructor(aggregateName) {
    this.type = Helper.OBJECT;
    this.title = aggregateName;
    this.properties = {};
    this.required = [];
    this.primaryKey = [];
  }

  setTitle(title) {
    this.title = title;
  }

  getTitle() {
    return this.title;
  }

  addNewProperty(porpName, propObj, isOptional = false) {
    this.properties[porpName] = propObj;
    if (
      propObj.type !== Helper.OBJECT &&
      propObj.type !== Helper.ARRAY &&
      !isOptional
    ) {
      this.required.push(porpName);
    }
  }

  getProperties() {
    return this.properties;
  }

  getPropertiesAt(key) {
    return this.properties[key];
  }

  getPrimaryKey() {
    return this.primaryKey;
  }

  addPrimaryKey(key) {
    if (!this.primaryKey.includes(key)) {
      this.primaryKey.push(key);
    }
  }

  getSpecificProp(prop) {
    const propName = prop.param.split(':')[0];
    const savedName =
      prop.entityName.toLowerCase() +
      propName[0].toUpperCase() +
      propName.substring(1);
    const currentProperty = this.getPropertiesAt(savedName);
    if (currentProperty) return [savedName, currentProperty];
    else {
      let name = '';
      if (prop.overRelation) {
        const overRelation = prop.overRelation.split('/');
        name = overRelation[overRelation.length - 1];
      } else {
        name = prop.entityName;
      }
      const currentProperty = this.getPropertiesAt(name);
      return [name, currentProperty];
    }
  }

  getNestedParameters() {
    const nestedParams = [];

    const propNames = Object.keys(this.properties);
    propNames.forEach(key => {
      const propObject = this.getPropertiesAt(key);
      if (propObject['type'] === 'array') {
        nestedParams.push(propObject);
      }
    });
    return nestedParams;
  }

  checkingNestedParams() {
    let numberOfNestedAttributes = 0;
    const numberOfattributes = [];
    const propertiesNames = Object.keys(this.getProperties());
    propertiesNames.forEach(key => {
      const propObject = this.getPropertiesAt(key);
      if (propObject['type'] === 'array') {
        numberOfNestedAttributes += 1;
        const arrayProps = Object.keys(propObject['items']['properties']);
        numberOfattributes.push(arrayProps.length);
      }
    });
    return [numberOfNestedAttributes, numberOfattributes];
  }

  isSimpleNestedParam(param) {
    const paramProperties = param['items']['properties'];
    const containedParams = Object.keys(paramProperties);
    try {
      containedParams.forEach(key => {
        const containedParam = paramProperties[key];
        if (containedParam['type'] === 'array') {
          throw 'Break';
        }
      });
    } catch (e) {
      if (e === 'Break') return false;
    }
    return true;
  }

  getSimpleNestedAttributes() {
    const allNestedParams = this.getNestedParameters();
    const simpleNestedAttributes = [];

    allNestedParams.forEach(nestedParam => {
      if (this.isSimpleNestedParam(nestedParam)) {
        simpleNestedAttributes.push(nestedParam);
      }
    });

    return simpleNestedAttributes;
  }

  canBeJoint(newSchame) {
    const keys = Object.keys(newSchame.getProperties());
    try {
      keys.forEach(key => {
        if (!this.getPropertiesAt(key)) {
          const property = newSchame.getPropertiesAt(key);
          if (property.getType() === Helper.ARRAY) {
            const arrayProperties = property.getItemsObj()['properties'];
            const arrayKeys = Object.keys(arrayProperties);
            if (arrayKeys.length > 1) {
              throw 'Break';
            }
          }
        }
      });
      return true;
    } catch (e) {
      if (e === 'Break') return false;
    }
  }

  joinSchema(newSchame) {
    const keys = Object.keys(newSchame.getProperties());
    keys.forEach(key => {
      if (!this.getPropertiesAt(key)) {
        const currentProp = newSchame.getPropertiesAt(key);
        this.addNewProperty(key, currentProp);
      }
    });
  }
}
